import type { ICellRendererParams } from 'ag-grid-community';
import Cell from './V5Gadget/Matrix/Cell';
import React from 'react';
import ErrorBoundary from './Common/ErrorBoundary';

const GridCellErrorBoundary = ({
  params,
  childComponent,
}: {
  params: ICellRendererParams;
  childComponent: React.ReactNode;
}) => {
  if (!params.data) {
    return <Cell>-</Cell>;
  }

  return (
    <ErrorBoundary isHiddenError>
      <>{childComponent}</>
    </ErrorBoundary>
  );
};

export default GridCellErrorBoundary;
